const ORDER_UPDATES = "order_updates";
const BACK_IN_STOCK_ALERTS = "back_in_stock_alerts";
const BACKORDER_UPDATES = "backorder_updates";
const MESSAGE_RECEIVED = "message_received";

const NotificationSettingTypeLabels = Object.freeze({
  [ORDER_UPDATES]: "Order Updates",
  [BACK_IN_STOCK_ALERTS]: "Back-in-Stock Alerts",
  [BACKORDER_UPDATES]: "Backorder Updates",
  [MESSAGE_RECEIVED]: "Message Received",
});

export default NotificationSettingTypeLabels;
